// Mock data for Morgan Guaranty Trust website

export const testimonials = [
  {
    id: 1,
    name: "Sophie Bennett",
    text: "I moved my savings to Morgan Guaranty Trust last year, and the experience has been excellent. Their team goes above and beyond to ensure your funds and investments are in safe hands. Highly recommended for anyone seeking stability and trust."
  },
  {
    id: 2,
    name: "Lucas Grant",
    text: "I appreciate how transparent and efficient Morgan Guaranty Trust is. Their services have made managing my finances easier, from daily transactions to long-term investments. I trust them completely with my financial future."
  },
  {
    id: 3,
    name: "Michael Carter",
    text: "Morgan Guaranty Trust has been my go-to financial partner for years. Their online banking system is secure and easy to use, and I've always experienced fast support whenever I needed assistance. A truly reliable institution."
  },
  {
    id: 4,
    name: "Emily Rodriguez",
    text: "The investment advisory services at Morgan Guaranty Trust are top-notch. My portfolio has grown steadily under their expert guidance, and I feel confident about my financial future."
  }
];

export const initiatives = [
  {
    id: 1,
    category: "Digital Banking",
    title: "Mobile Banking App",
    subtitle: "Digital Transformation",
    image: "https://images.unsplash.com/photo-1681826291722-70bd7e9e6fc3"
  },
  {
    id: 2,
    category: "Digital Banking",
    title: "Smart Wealth Program",
    subtitle: "Investment Innovation",
    image: "https://images.pexels.com/photos/163056/computer-buy-money-banknotes-163056.jpeg"
  },
  {
    id: 3,
    category: "Savings",
    title: "Smart Savings Plan",
    subtitle: "Customer Empowerment",
    image: "https://images.pexels.com/photos/1602726/pexels-photo-1602726.jpeg"
  },
  {
    id: 4,
    category: "Digital Banking",
    title: "Online Account Opening",
    subtitle: "Next-Gen Banking",
    image: "https://images.unsplash.com/photo-1609921141835-710b7fa6e438"
  },
  {
    id: 5,
    category: "Digital Banking",
    title: "Virtual Banking Assistant",
    subtitle: "AI-Driven Experience",
    image: "https://images.unsplash.com/photo-1599202875854-23b7cd490ff4"
  },
  {
    id: 6,
    category: "Digital Banking",
    title: "Enhanced Mobile Security",
    subtitle: "Secure Transactions",
    image: "https://images.unsplash.com/photo-1616077168712-fc6c788db4af"
  },
  {
    id: 7,
    category: "Corporate",
    title: "Corporate Partnership Program",
    subtitle: "Business Support",
    image: "https://images.unsplash.com/photo-1686771416282-3888ddaf249b"
  },
  {
    id: 8,
    category: "Corporate",
    title: "SME Support Initiative",
    subtitle: "Enterprise Growth",
    image: "https://images.unsplash.com/photo-1616587656977-ac36a5a430bc"
  },
  {
    id: 9,
    category: "Corporate",
    title: "Global Business Solutions",
    subtitle: "Trade & Finance",
    image: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4"
  },
  {
    id: 10,
    category: "Savings",
    title: "Goal-Based Savings",
    subtitle: "Personal Finance",
    image: "https://images.pexels.com/photos/3943723/pexels-photo-3943723.jpeg"
  },
  {
    id: 11,
    category: "Savings",
    title: "Future Saver Account",
    subtitle: "Youth Banking",
    image: "https://images.pexels.com/photos/4968391/pexels-photo-4968391.jpeg"
  },
  {
    id: 12,
    category: "Savings",
    title: "SheInvest Program",
    subtitle: "Women Empowerment",
    image: "https://images.unsplash.com/photo-1681826292838-c37fbd22263a"
  },
  {
    id: 13,
    category: "Community",
    title: "Community Development Fund",
    subtitle: "CSR Initiative",
    image: "https://images.pexels.com/photos/3531895/pexels-photo-3531895.jpeg"
  },
  {
    id: 14,
    category: "Community",
    title: "Empower Learning Program",
    subtitle: "Financial Literacy",
    image: "https://images.pexels.com/photos/50987/money-card-business-credit-card-50987.jpeg"
  },
  {
    id: 15,
    category: "Community",
    title: "Business Outreach Program",
    subtitle: "Partnership Growth",
    image: "https://images.pexels.com/photos/4482900/pexels-photo-4482900.jpeg"
  }
];

export const services = [
  {
    id: 1,
    title: "Personal Banking",
    description: "From savings and current accounts to digital banking solutions, we provide secure and convenient financial services designed to support your everyday needs and future goals.",
    link: "/personal",
    number: "01"
  },
  {
    id: 2,
    title: "Investment Solutions",
    description: "We help you grow and protect your wealth through expert financial advice, tailored investment portfolios, and innovative market opportunities built on trust and transparency.",
    link: "/insurance",
    number: "02"
  },
  {
    id: 3,
    title: "Corporate Banking",
    description: "Empowering businesses with comprehensive financial solutions — including corporate accounts, treasury management, and trade finance — to help organizations thrive locally and globally.",
    link: "/corporate",
    number: "03"
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Open an Account",
    description: "Begin your journey with Morgan Guaranty Trust by setting up a secure personal or business account. Our simplified digital onboarding makes registration fast and effortless.",
    number: "01"
  },
  {
    id: 2,
    title: "Secure Transactions",
    description: "Manage your finances safely through advanced encryption and 24/7 monitoring. Every transaction is protected to ensure complete peace of mind.",
    number: "02"
  },
  {
    id: 3,
    title: "Grow Your Wealth",
    description: "Access personalized financial solutions designed to help you reach your goals — from savings and investments to long-term wealth management strategies.",
    number: "03"
  }
];
